module.exports = __webpack_public_path__ + "static/media/20170806_04day_0192AT.735d79b2.jpg";